import { padTo2Digits } from "./modifyDate";

// !!!!for master use this
export const url = window.origin.replace(`.${process.env.REACT_APP_WEBSITE_NAME}`, "").replace(`${process.env.REACT_APP_WEBSITE_NAME}`, "");
const checkOrigin = window.origin.replace("www.", "").includes(process.env.REACT_APP_WEBSITE_NAME)
const apiUrl = checkOrigin
? url + `.api.${process.env.REACT_APP_WEBSITE_NAME}/api/v1/`
: process.env.REACT_APP_BASIC_API;


// !!!!for dev use this
// export const url = window.origin.replace(`.${process.env.REACT_APP_WEBSITE_NAME}`, "");
// const apiUrl = window.origin.includes(process.env.REACT_APP_WEBSITE_NAME)
//   ? url + `.api.${process.env.REACT_APP_WEBSITE_NAME}/api/v1/`
//   : process.env.REACT_APP_BASIC_API;

export const API_URL =
  process.env.REACT_APP_DEVELOPMENT_MODE === "production"
    ? apiUrl.replace("www.", "")
    : process.env.REACT_APP_BASIC_API.replace("www.", "");

export const SOCKET_URL = API_URL.replace("https://", "wss://").replace(/\/api\/v\d+\/$/, "");

// API host without /api/v1/ suffix
export const API_HOST = API_URL.replace(/\/api\/v\d+\/$/, '');

// Domain configuration from environment
export const WEBSITE_NAME = process.env.REACT_APP_WEBSITE_NAME;
export const WEBSITE_DOMAIN = `.${WEBSITE_NAME}`;

export const TIMEZONE_LIST = [
  {
    title: "EET Eastern European Time GMT+2",
    value: "Europe/Kyiv",
  },
  {
    title: "CET Central European Time GMT+1",
    value: "Europe/Warsaw",
  },
  {
    title: "GMT Greenwich Mean Time GMT+0",
    value: "Europe/London",
  },
  {
    title: "UTC+0",
    value: "UTC",
  },
  {
    title: "EST Eastern Standard Time GMT−5",
    value: "US/Eastern",
  },
  {
    title: "CST Central Standard Time GMT−6",
    value: "US/Central",
  },
  {
    title: "MST Mountain Standard Time GMT−7",
    value: "US/Mountain",
  },
  {
    title: "PST Pacific Standard Time GMT−8",
    value: "US/Pacific",
  },
];

export const days = [
  { label: "Monday", value: "mon", disabled: false },
  { label: "Tuesday", value: "tue", disabled: false },
  { label: "Wednesday", value: "wed", disabled: false },
  { label: "Thursday", value: "thu", disabled: false },
  { label: "Friday", value: "fri", disabled: false },
  { label: "Saturday", value: "sat", disabled: false },
  { label: "Sunday", value: "sun", disabled: false },
];

export const hours = [];
for (let i = 0; i <= 23; i += 1) {
  hours.push(padTo2Digits(i));
}

export const minutes = [];
for (let i = 0; i <= 59; i += 1) {
  minutes.push(padTo2Digits(i));
}

export const time = {
  hours,
  minutes,
};

export const BREAKPOINT = {
  media_md: 1024,
  media_lg: 1440,
  media_xl: 1580,
  media_fullhd: 1920,
};

export const usaStates = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const canadianProvincesAndTerritories = [
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NT", label: "Northwest Territories" },
  { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon" },
];
